import React from 'react';

import {CopyButton} from 'src/components/copy-button';

import {Group, Item} from '@pb/kit-component-group';
import {Sizes} from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {AccountHierarchyIcon} from './account-hierarchy-icon';
import {DeleteAccount} from './components/delete-account';
import {RestoreAccount} from './components/restore-account';

import {
    accountPageHeader,
    accountPageHeaderMeta,
} from './account-page.module.styl';

import type {AccountHierarchyTree} from 'src/openapi/admin/models/AccountHierarchyTree';


type Props = {
    id: number,
    hierarchy: AccountHierarchyTree | null,
    onChangeAccount: () => void,
};

export const AccountPageHeader: React.FC<Props> = ({id, hierarchy, onChangeAccount}) => (

    <Group className={accountPageHeader}>
        <Item grow={1}>
            <Group justify="space-between" alignItems="center">
                <Group alignItems="center">
                    <div className="enable-selection">
                        <Typography variant="heading-level-1">
                            {hierarchy?.current?.name} {hierarchy?.current?.isDeleted ? '(Deleted)' : ''}
                        </Typography>
                    </div>
                    <div className={accountPageHeaderMeta}>
                        <span className="enable-selection">ID {id}</span>
                    </div>
                    <CopyButton copiedText={id.toString()} entityName="Account ID" iconSize={Sizes.Size_16}/>
                    {(hierarchy?.parent || hierarchy?.child) ? <AccountHierarchyIcon hierarchy={hierarchy}/> : null}
                </Group>
                {hierarchy?.current?.isDeleted ? (
                    <RestoreAccount
                        accountId={id}
                        onDone={onChangeAccount}
                    />
                ) : (
                    <DeleteAccount
                        accountId={id}
                        onDone={onChangeAccount}
                    />
                )}
            </Group>
        </Item>
    </Group>
);
